import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["master", "options"]

  connect() {
    this.update()
  }

  update() {
    const enabled = this.masterTarget.checked
    this.optionsTarget.hidden = !enabled
    this.optionsTarget.querySelectorAll("input").forEach(input => { input.disabled = !enabled })
  }

  explain(event) {
    this.element.querySelector(`#${event.currentTarget.dataset.dialog}`).showModal()
  }

  close(event) {
    event.currentTarget.closest("dialog").close()
  }
}
